import { motion } from "framer-motion";
import { Trash2, PlayCircle, User2 } from "lucide-react";
import { formatDuration } from "../lib/format";
import { HOME } from "../constants/testIds";

export const HistoryGrid = ({ items, onClear, onReuse }) => {
  if (!items || items.length === 0) return null;

  return (
    <section data-testid={HOME.historySection} className="relative pb-24">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex items-end justify-between mb-8">
          <h2 className="font-heading text-xl font-bold tracking-tight text-zinc-300">
            История
          </h2>
          <button
            data-testid={HOME.clearHistory}
            onClick={onClear}
            className="inline-flex items-center gap-2 text-xs text-zinc-400 hover:text-white border border-white/10 hover:border-white/25 rounded-full px-3 py-1.5 transition-colors duration-200"
          >
            <Trash2 className="w-3.5 h-3.5" />
            Очистить
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {items.map((item, i) => (
            <motion.button
              data-testid={`history-item-${item.id}`}
              key={item.id}
              onClick={() => onReuse(item)}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.04, duration: 0.35, ease: "easeOut" }}
              className="group text-left rounded-2xl border border-white/10 bg-[#0a0a0b] overflow-hidden hover:border-pink-600/40 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(220,39,67,0.5)] transition-[transform,border-color,box-shadow] duration-300"
            >
              <div className="relative aspect-[9/13] bg-black overflow-hidden">
                {item.thumbnail ? (
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    referrerPolicy="no-referrer"
                    onError={(e) => (e.currentTarget.style.display = "none")}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-zinc-700 text-xs uppercase">
                    {item.kind}
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                <div className="absolute top-3 left-3 inline-flex items-center gap-1 text-[9px] font-bold tracking-widest bg-black/70 border border-white/15 rounded-full px-2 py-0.5">
                  {(item.media_type === "image" ? "PHOTO" : item.kind?.toUpperCase())}
                </div>
                {item.media_type !== "image" && (
                  <div className="absolute bottom-3 right-3 inline-flex items-center gap-1 text-[10px] bg-black/70 border border-white/10 rounded-full px-2 py-0.5 text-zinc-200">
                    {formatDuration(item.duration)}
                  </div>
                )}
                <PlayCircle className="absolute inset-0 m-auto w-10 h-10 text-white/0 group-hover:text-white/90 transition-colors duration-300" />
              </div>
              <div className="p-3">
                <p className="text-sm font-medium line-clamp-1 text-zinc-100">
                  {item.title || "Без названия"}
                </p>
                {item.uploader && (
                  <p className="text-xs text-zinc-500 mt-1 inline-flex items-center gap-1">
                    <User2 className="w-3 h-3" />@{item.uploader}
                  </p>
                )}
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
